class ProductInfoScrollController {
    constructor(options = {}) {
        this.config = {
            expandableContentSelector: '.product__expandable-content',
            scrollWrapperSelector: '.product__info-wrapper',
            scrollThreshold: 35,
            animationDuration: 400,
            ...options
        };
        
        this.state = {
            isExpanded: false,
            hasBeenExpanded: false,
            isAnimating: false,
            initialScrollPosition: 0
        };
        
        this.elements = {};
        this.bindMethods();
        this.init();
    }
    
    bindMethods() {
        this.handleScroll = this.handleScroll.bind(this);
    }
    
    init() {
        if (!this.isMobile()) return;
        
        this.cacheElements();
        this.setupInitialState();
        this.attachEventListeners();        
    }
    
    cacheElements() {
        this.elements.expandableContent = document.querySelector(this.config.expandableContentSelector);
        this.elements.scrollWrapper = document.querySelector(this.config.scrollWrapperSelector);
    }
    
    setupInitialState() {
        if (!this.elements.expandableContent || !this.elements.scrollWrapper) return;
        this.elements.expandableContent.classList.remove('is-visible');        
        this.state.initialScrollPosition = this.elements.scrollWrapper.scrollTop <= 10 ? 0 : this.elements.scrollWrapper.scrollTop;
    }
    
    attachEventListeners() {
        if (!this.elements.scrollWrapper) return;
        
        let ticking = false;
        
        const throttledScroll = () => {
            if (!ticking) {
                requestAnimationFrame(() => {                    
                    this.handleScroll();
                    ticking = false;
                });
                ticking = true;
            }
        };
        
        this.elements.scrollWrapper.addEventListener('scroll', throttledScroll, { passive: true });
    }
    
    isMobile() {
        return window.innerWidth > 749;
    }

    handleScroll() {        
        const currentScrollY = this.elements.scrollWrapper.scrollTop;
        const scrollDelta = currentScrollY - this.state.initialScrollPosition;
        
        if (this.shouldExpandContent(scrollDelta, currentScrollY)) {
            this.expandContent();
        } else if (this.shouldCollapseContent(currentScrollY)) {
            this.collapseContent();
        }
    }
    
    shouldExpandContent(scrollDelta, currentScrollY) {
        return !this.state.isExpanded && 
               scrollDelta > this.config.scrollThreshold && 
               currentScrollY > this.config.scrollThreshold;
    }
    
    shouldCollapseContent(currentScrollY) {
        return this.state.isExpanded &&
           this.state.hasBeenExpanded &&
           currentScrollY <= 10;
    }
    
    expandContent() {
        if (this.state.isAnimating || this.state.isExpanded) return;
        
        this.state.isAnimating = true;
        this.state.isExpanded = true;
        this.state.hasBeenExpanded = true;
        
        const element = this.elements.expandableContent;        
        element.classList.add('is-visible');
        
        setTimeout(() => {
            this.state.isAnimating = false;
        }, this.config.animationDuration);
    }
    
    collapseContent() {
        if (this.state.isAnimating || !this.state.isExpanded) return;

        this.state.isAnimating = true;
        this.state.isExpanded = false;

        const element = this.elements.expandableContent;
        element.classList.remove('is-visible');

        setTimeout(() => {
            this.state.isAnimating = false;
        }, this.config.animationDuration);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new ProductInfoScrollController();
});